// 完整的地址数据库 - 支持中国全国及海外主要国家

// ==================== 中国地址数据 ====================
// 省份 -> 城市 -> 区县 -> 邮编前缀
export interface ChinaDistrict {
  name: string;
  postalCode: string; // 6位邮编
}

export interface ChinaCity {
  name: string;
  districts: ChinaDistrict[];
}

export interface ChinaProvince {
  name: string;
  cities: ChinaCity[];
}

export const chinaAddressData: ChinaProvince[] = [
  // 直辖市
  {
    name: '北京市',
    cities: [
      {
        name: '北京市',
        districts: [
          { name: '东城区', postalCode: '100010' },
          { name: '西城区', postalCode: '100032' },
          { name: '朝阳区', postalCode: '100020' },
          { name: '丰台区', postalCode: '100071' },
          { name: '石景山区', postalCode: '100043' },
          { name: '海淀区', postalCode: '100089' },
          { name: '门头沟区', postalCode: '102300' },
          { name: '房山区', postalCode: '102488' },
          { name: '通州区', postalCode: '101100' },
          { name: '顺义区', postalCode: '101300' },
          { name: '昌平区', postalCode: '102200' },
          { name: '大兴区', postalCode: '102600' },
          { name: '怀柔区', postalCode: '101400' },
          { name: '平谷区', postalCode: '101200' },
          { name: '密云区', postalCode: '101500' },
          { name: '延庆区', postalCode: '102100' },
        ]
      }
    ]
  },
  {
    name: '天津市',
    cities: [
      {
        name: '天津市',
        districts: [
          { name: '和平区', postalCode: '300041' },
          { name: '河东区', postalCode: '300171' },
          { name: '河西区', postalCode: '300202' },
          { name: '南开区', postalCode: '300110' },
          { name: '河北区', postalCode: '300143' },
          { name: '红桥区', postalCode: '300131' },
          { name: '东丽区', postalCode: '300300' },
          { name: '西青区', postalCode: '300380' },
          { name: '津南区', postalCode: '300350' },
          { name: '北辰区', postalCode: '300400' },
          { name: '武清区', postalCode: '301700' },
          { name: '宝坻区', postalCode: '301800' },
          { name: '滨海新区', postalCode: '300450' },
          { name: '宁河区', postalCode: '301500' },
          { name: '静海区', postalCode: '301600' },
          { name: '蓟州区', postalCode: '301900' },
        ]
      }
    ]
  },
  {
    name: '上海市',
    cities: [
      {
        name: '上海市',
        districts: [
          { name: '黄浦区', postalCode: '200001' },
          { name: '徐汇区', postalCode: '200030' },
          { name: '长宁区', postalCode: '200050' },
          { name: '静安区', postalCode: '200040' },
          { name: '普陀区', postalCode: '200333' },
          { name: '虹口区', postalCode: '200080' },
          { name: '杨浦区', postalCode: '200090' },
          { name: '闵行区', postalCode: '201100' },
          { name: '宝山区', postalCode: '201900' },
          { name: '嘉定区', postalCode: '201800' },
          { name: '浦东新区', postalCode: '200120' },
          { name: '金山区', postalCode: '201500' },
          { name: '松江区', postalCode: '201600' },
          { name: '青浦区', postalCode: '201700' },
          { name: '奉贤区', postalCode: '201400' },
          { name: '崇明区', postalCode: '202150' },
        ]
      }
    ]
  },
  {
    name: '重庆市',
    cities: [
      {
        name: '重庆市',
        districts: [
          { name: '渝中区', postalCode: '400010' },
          { name: '大渡口区', postalCode: '400084' },
          { name: '江北区', postalCode: '400020' },
          { name: '沙坪坝区', postalCode: '400030' },
          { name: '九龙坡区', postalCode: '400050' },
          { name: '南岸区', postalCode: '400060' },
          { name: '北碚区', postalCode: '400700' },
          { name: '渝北区', postalCode: '401120' },
          { name: '巴南区', postalCode: '401320' },
          { name: '涪陵区', postalCode: '408000' },
          { name: '綦江区', postalCode: '401420' },
          { name: '大足区', postalCode: '402360' },
          { name: '长寿区', postalCode: '401220' },
          { name: '江津区', postalCode: '402260' },
          { name: '合川区', postalCode: '401520' },
          { name: '永川区', postalCode: '402160' },
        ]
      }
    ]
  },

  // 华北地区
  {
    name: '河北省',
    cities: [
      {
        name: '石家庄市',
        districts: [
          { name: '长安区', postalCode: '050011' },
          { name: '桥西区', postalCode: '050091' },
          { name: '新华区', postalCode: '050051' },
          { name: '井陉矿区', postalCode: '050100' },
          { name: '裕华区', postalCode: '050031' },
          { name: '藁城区', postalCode: '052160' },
          { name: '鹿泉区', postalCode: '050200' },
          { name: '栾城区', postalCode: '051430' },
        ]
      },
      {
        name: '唐山市',
        districts: [
          { name: '路南区', postalCode: '063000' },
          { name: '路北区', postalCode: '063000' },
          { name: '古冶区', postalCode: '063100' },
          { name: '开平区', postalCode: '063021' },
          { name: '丰南区', postalCode: '063300' },
          { name: '丰润区', postalCode: '064000' },
          { name: '曹妃甸区', postalCode: '063200' },
        ]
      },
      {
        name: '秦皇岛市',
        districts: [
          { name: '海港区', postalCode: '066000' },
          { name: '山海关区', postalCode: '066200' },
          { name: '北戴河区', postalCode: '066100' },
          { name: '抚宁区', postalCode: '066300' },
        ]
      },
      {
        name: '邯郸市',
        districts: [
          { name: '邯山区', postalCode: '056001' },
          { name: '丛台区', postalCode: '056002' },
          { name: '复兴区', postalCode: '056003' },
          { name: '峰峰矿区', postalCode: '056200' },
        ]
      },
      {
        name: '保定市',
        districts: [
          { name: '竞秀区', postalCode: '071000' },
          { name: '莲池区', postalCode: '071000' },
          { name: '满城区', postalCode: '072150' },
          { name: '清苑区', postalCode: '071100' },
          { name: '徐水区', postalCode: '072550' },
        ]
      },
      {
        name: '廊坊市',
        districts: [
          { name: '安次区', postalCode: '065000' },
          { name: '广阳区', postalCode: '065000' },
          { name: '固安县', postalCode: '065500' },
          { name: '香河县', postalCode: '065400' },
          { name: '大厂回族自治县', postalCode: '065300' },
        ]
      },
    ]
  },
  {
    name: '山西省',
    cities: [
      {
        name: '太原市',
        districts: [
          { name: '小店区', postalCode: '030032' },
          { name: '迎泽区', postalCode: '030002' },
          { name: '杏花岭区', postalCode: '030009' },
          { name: '尖草坪区', postalCode: '030023' },
          { name: '万柏林区', postalCode: '030024' },
          { name: '晋源区', postalCode: '030025' },
        ]
      },
      {
        name: '大同市',
        districts: [
          { name: '平城区', postalCode: '037006' },
          { name: '云冈区', postalCode: '037003' },
          { name: '新荣区', postalCode: '037002' },
          { name: '云州区', postalCode: '037300' },
        ]
      },
      {
        name: '阳泉市',
        districts: [
          { name: '城区', postalCode: '045000' },
          { name: '矿区', postalCode: '045000' },
          { name: '郊区', postalCode: '045011' },
        ]
      },
      {
        name: '长治市',
        districts: [
          { name: '潞州区', postalCode: '046000' },
          { name: '上党区', postalCode: '047100' },
          { name: '屯留区', postalCode: '046100' },
          { name: '潞城区', postalCode: '047500' },
        ]
      },
    ]
  },
  {
    name: '内蒙古自治区',
    cities: [
      {
        name: '呼和浩特市',
        districts: [
          { name: '新城区', postalCode: '010010' },
          { name: '回民区', postalCode: '010030' },
          { name: '玉泉区', postalCode: '010020' },
          { name: '赛罕区', postalCode: '010020' },
        ]
      },
      {
        name: '包头市',
        districts: [
          { name: '东河区', postalCode: '014040' },
          { name: '昆都仑区', postalCode: '014010' },
          { name: '青山区', postalCode: '014030' },
          { name: '石拐区', postalCode: '014070' },
          { name: '九原区', postalCode: '014060' },
        ]
      },
      {
        name: '赤峰市',
        districts: [
          { name: '红山区', postalCode: '024000' },
          { name: '元宝山区', postalCode: '024076' },
          { name: '松山区', postalCode: '024005' },
        ]
      },
      {
        name: '鄂尔多斯市',
        districts: [
          { name: '东胜区', postalCode: '017000' },
          { name: '康巴什区', postalCode: '017010' },
          { name: '达拉特旗', postalCode: '014300' },
          { name: '准格尔旗', postalCode: '010400' },
        ]
      },
    ]
  },

  // 东北地区
  {
    name: '辽宁省',
    cities: [
      {
        name: '沈阳市',
        districts: [
          { name: '和平区', postalCode: '110001' },
          { name: '沈河区', postalCode: '110011' },
          { name: '大东区', postalCode: '110041' },
          { name: '皇姑区', postalCode: '110031' },
          { name: '铁西区', postalCode: '110021' },
          { name: '苏家屯区', postalCode: '110101' },
          { name: '浑南区', postalCode: '110166' },
          { name: '沈北新区', postalCode: '110121' },
          { name: '于洪区', postalCode: '110141' },
        ]
      },
      {
        name: '大连市',
        districts: [
          { name: '中山区', postalCode: '116001' },
          { name: '西岗区', postalCode: '116011' },
          { name: '沙河口区', postalCode: '116021' },
          { name: '甘井子区', postalCode: '116033' },
          { name: '旅顺口区', postalCode: '116041' },
          { name: '金州区', postalCode: '116100' },
          { name: '普兰店区', postalCode: '116200' },
        ]
      },
      {
        name: '鞍山市',
        districts: [
          { name: '铁东区', postalCode: '114001' },
          { name: '铁西区', postalCode: '114013' },
          { name: '立山区', postalCode: '114031' },
          { name: '千山区', postalCode: '114041' },
        ]
      },
      {
        name: '抚顺市',
        districts: [
          { name: '新抚区', postalCode: '113008' },
          { name: '东洲区', postalCode: '113003' },
          { name: '望花区', postalCode: '113001' },
          { name: '顺城区', postalCode: '113006' },
        ]
      },
    ]
  },
  {
    name: '吉林省',
    cities: [
      {
        name: '长春市',
        districts: [
          { name: '南关区', postalCode: '130022' },
          { name: '宽城区', postalCode: '130051' },
          { name: '朝阳区', postalCode: '130012' },
          { name: '二道区', postalCode: '130031' },
          { name: '绿园区', postalCode: '130062' },
          { name: '双阳区', postalCode: '130600' },
          { name: '九台区', postalCode: '130500' },
        ]
      },
      {
        name: '吉林市',
        districts: [
          { name: '昌邑区', postalCode: '132002' },
          { name: '龙潭区', postalCode: '132021' },
          { name: '船营区', postalCode: '132011' },
          { name: '丰满区', postalCode: '132013' },
        ]
      },
      {
        name: '四平市',
        districts: [
          { name: '铁西区', postalCode: '136000' },
          { name: '铁东区', postalCode: '136001' },
        ]
      },
      {
        name: '延边朝鲜族自治州',
        districts: [
          { name: '延吉市', postalCode: '133000' },
          { name: '图们市', postalCode: '133100' },
          { name: '敦化市', postalCode: '133700' },
          { name: '珲春市', postalCode: '133300' },
        ]
      },
    ]
  },
  {
    name: '黑龙江省',
    cities: [
      {
        name: '哈尔滨市',
        districts: [
          { name: '道里区', postalCode: '150010' },
          { name: '南岗区', postalCode: '150001' },
          { name: '道外区', postalCode: '150020' },
          { name: '平房区', postalCode: '150060' },
          { name: '松北区', postalCode: '150028' },
          { name: '香坊区', postalCode: '150036' },
          { name: '呼兰区', postalCode: '150500' },
          { name: '阿城区', postalCode: '150300' },
          { name: '双城区', postalCode: '150100' },
        ]
      },
      {
        name: '齐齐哈尔市',
        districts: [
          { name: '龙沙区', postalCode: '161000' },
          { name: '建华区', postalCode: '161006' },
          { name: '铁锋区', postalCode: '161002' },
          { name: '昂昂溪区', postalCode: '161031' },
          { name: '富拉尔基区', postalCode: '161041' },
        ]
      },
      {
        name: '牡丹江市',
        districts: [
          { name: '东安区', postalCode: '157000' },
          { name: '阳明区', postalCode: '157013' },
          { name: '爱民区', postalCode: '157009' },
          { name: '西安区', postalCode: '157000' },
        ]
      },
      {
        name: '大庆市',
        districts: [
          { name: '萨尔图区', postalCode: '163001' },
          { name: '龙凤区', postalCode: '163711' },
          { name: '让胡路区', postalCode: '163712' },
          { name: '红岗区', postalCode: '163511' },
          { name: '大同区', postalCode: '163515' },
        ]
      },
    ]
  },

  // 华东地区
  {
    name: '江苏省',
    cities: [
      {
        name: '南京市',
        districts: [
          { name: '玄武区', postalCode: '210018' },
          { name: '秦淮区', postalCode: '210001' },
          { name: '建邺区', postalCode: '210004' },
          { name: '鼓楼区', postalCode: '210009' },
          { name: '浦口区', postalCode: '211800' },
          { name: '栖霞区', postalCode: '210046' },
          { name: '雨花台区', postalCode: '210012' },
          { name: '江宁区', postalCode: '211100' },
          { name: '六合区', postalCode: '211500' },
          { name: '溧水区', postalCode: '211200' },
          { name: '高淳区', postalCode: '211300' },
        ]
      },
      {
        name: '苏州市',
        districts: [
          { name: '虎丘区', postalCode: '215004' },
          { name: '吴中区', postalCode: '215128' },
          { name: '相城区', postalCode: '215131' },
          { name: '姑苏区', postalCode: '215005' },
          { name: '吴江区', postalCode: '215200' },
          { name: '昆山市', postalCode: '215300' },
          { name: '太仓市', postalCode: '215400' },
          { name: '常熟市', postalCode: '215500' },
          { name: '张家港市', postalCode: '215600' },
        ]
      },
      {
        name: '无锡市',
        districts: [
          { name: '锡山区', postalCode: '214101' },
          { name: '惠山区', postalCode: '214174' },
          { name: '滨湖区', postalCode: '214123' },
          { name: '梁溪区', postalCode: '214001' },
          { name: '新吴区', postalCode: '214028' },
          { name: '江阴市', postalCode: '214400' },
          { name: '宜兴市', postalCode: '214200' },
        ]
      },
      {
        name: '常州市',
        districts: [
          { name: '天宁区', postalCode: '213000' },
          { name: '钟楼区', postalCode: '213023' },
          { name: '新北区', postalCode: '213022' },
          { name: '武进区', postalCode: '213100' },
          { name: '金坛区', postalCode: '213200' },
          { name: '溧阳市', postalCode: '213300' },
        ]
      },
      {
        name: '南通市',
        districts: [
          { name: '崇川区', postalCode: '226001' },
          { name: '港闸区', postalCode: '226005' },
          { name: '通州区', postalCode: '226300' },
          { name: '海门区', postalCode: '226100' },
          { name: '启东市', postalCode: '226200' },
          { name: '如皋市', postalCode: '226500' },
        ]
      },
      {
        name: '扬州市',
        districts: [
          { name: '广陵区', postalCode: '225001' },
          { name: '邗江区', postalCode: '225002' },
          { name: '江都区', postalCode: '225200' },
          { name: '仪征市', postalCode: '211400' },
          { name: '高邮市', postalCode: '225600' },
        ]
      },
    ]
  },
  {
    name: '浙江省',
    cities: [
      {
        name: '杭州市',
        districts: [
          { name: '上城区', postalCode: '310002' },
          { name: '拱墅区', postalCode: '310015' },
          { name: '西湖区', postalCode: '310013' },
          { name: '滨江区', postalCode: '310051' },
          { name: '萧山区', postalCode: '311200' },
          { name: '余杭区', postalCode: '311100' },
          { name: '临平区', postalCode: '311100' },
          { name: '钱塘区', postalCode: '310018' },
          { name: '富阳区', postalCode: '311400' },
          { name: '临安区', postalCode: '311300' },
        ]
      },
      {
        name: '宁波市',
        districts: [
          { name: '海曙区', postalCode: '315000' },
          { name: '江北区', postalCode: '315020' },
          { name: '北仑区', postalCode: '315800' },
          { name: '镇海区', postalCode: '315200' },
          { name: '鄞州区', postalCode: '315100' },
          { name: '奉化区', postalCode: '315500' },
          { name: '余姚市', postalCode: '315400' },
          { name: '慈溪市', postalCode: '315300' },
        ]
      },
      {
        name: '温州市',
        districts: [
          { name: '鹿城区', postalCode: '325000' },
          { name: '龙湾区', postalCode: '325013' },
          { name: '瓯海区', postalCode: '325005' },
          { name: '洞头区', postalCode: '325700' },
          { name: '瑞安市', postalCode: '325200' },
          { name: '乐清市', postalCode: '325600' },
        ]
      },
      {
        name: '嘉兴市',
        districts: [
          { name: '南湖区', postalCode: '314001' },
          { name: '秀洲区', postalCode: '314031' },
          { name: '海宁市', postalCode: '314400' },
          { name: '平湖市', postalCode: '314200' },
          { name: '桐乡市', postalCode: '314500' },
          { name: '嘉善县', postalCode: '314100' },
        ]
      },
      {
        name: '绍兴市',
        districts: [
          { name: '越城区', postalCode: '312000' },
          { name: '柯桥区', postalCode: '312030' },
          { name: '上虞区', postalCode: '312300' },
          { name: '诸暨市', postalCode: '311800' },
          { name: '嵊州市', postalCode: '312400' },
        ]
      },
      {
        name: '金华市',
        districts: [
          { name: '婺城区', postalCode: '321000' },
          { name: '金东区', postalCode: '321015' },
          { name: '义乌市', postalCode: '322000' },
          { name: '东阳市', postalCode: '322100' },
          { name: '永康市', postalCode: '321300' },
        ]
      },
    ]
  },
  {
    name: '安徽省',
    cities: [
      {
        name: '合肥市',
        districts: [
          { name: '瑶海区', postalCode: '230011' },
          { name: '庐阳区', postalCode: '230001' },
          { name: '蜀山区', postalCode: '230031' },
          { name: '包河区', postalCode: '230041' },
          { name: '长丰县', postalCode: '231100' },
          { name: '肥东县', postalCode: '231600' },
          { name: '肥西县', postalCode: '231200' },
          { name: '庐江县', postalCode: '231500' },
          { name: '巢湖市', postalCode: '238000' },
        ]
      },
      {
        name: '芜湖市',
        districts: [
          { name: '镜湖区', postalCode: '241000' },
          { name: '弋江区', postalCode: '241002' },
          { name: '鸠江区', postalCode: '241006' },
          { name: '湾沚区', postalCode: '241100' },
          { name: '繁昌区', postalCode: '241200' },
        ]
      },
      {
        name: '蚌埠市',
        districts: [
          { name: '龙子湖区', postalCode: '233000' },
          { name: '蚌山区', postalCode: '233000' },
          { name: '禹会区', postalCode: '233010' },
          { name: '淮上区', postalCode: '233002' },
        ]
      },
      {
        name: '淮南市',
        districts: [
          { name: '大通区', postalCode: '232033' },
          { name: '田家庵区', postalCode: '232000' },
          { name: '谢家集区', postalCode: '232052' },
          { name: '八公山区', postalCode: '232072' },
          { name: '潘集区', postalCode: '232082' },
        ]
      },
    ]
  },

  {
    name: '福建省',
    cities: [
      {
        name: '福州市',
        districts: [
          { name: '鼓楼区', postalCode: '350001' },
          { name: '台江区', postalCode: '350004' },
          { name: '仓山区', postalCode: '350007' },
          { name: '马尾区', postalCode: '350015' },
          { name: '晋安区', postalCode: '350011' },
          { name: '长乐区', postalCode: '350200' },
          { name: '福清市', postalCode: '350300' },
        ]
      },
      {
        name: '厦门市',
        districts: [
          { name: '思明区', postalCode: '361001' },
          { name: '海沧区', postalCode: '361026' },
          { name: '湖里区', postalCode: '361006' },
          { name: '集美区', postalCode: '361021' },
          { name: '同安区', postalCode: '361100' },
          { name: '翔安区', postalCode: '361101' },
        ]
      },
      {
        name: '泉州市',
        districts: [
          { name: '鲤城区', postalCode: '362000' },
          { name: '丰泽区', postalCode: '362000' },
          { name: '洛江区', postalCode: '362011' },
          { name: '泉港区', postalCode: '362801' },
          { name: '晋江市', postalCode: '362200' },
          { name: '石狮市', postalCode: '362700' },
        ]
      },
      {
        name: '漳州市',
        districts: [
          { name: '芗城区', postalCode: '363000' },
          { name: '龙文区', postalCode: '363005' },
          { name: '龙海区', postalCode: '363100' },
          { name: '长泰区', postalCode: '363900' },
        ]
      },
    ]
  },
  {
    name: '江西省',
    cities: [
      {
        name: '南昌市',
        districts: [
          { name: '东湖区', postalCode: '330006' },
          { name: '西湖区', postalCode: '330009' },
          { name: '青云谱区', postalCode: '330001' },
          { name: '青山湖区', postalCode: '330029' },
          { name: '新建区', postalCode: '330100' },
          { name: '红谷滩区', postalCode: '330038' },
        ]
      },
      {
        name: '九江市',
        districts: [
          { name: '濂溪区', postalCode: '332005' },
          { name: '浔阳区', postalCode: '332000' },
          { name: '柴桑区', postalCode: '332100' },
          { name: '庐山市', postalCode: '332800' },
        ]
      },
      {
        name: '赣州市',
        districts: [
          { name: '章贡区', postalCode: '341000' },
          { name: '南康区', postalCode: '341400' },
          { name: '赣县区', postalCode: '341100' },
          { name: '瑞金市', postalCode: '342500' },
        ]
      },
    ]
  },
  {
    name: '山东省',
    cities: [
      {
        name: '济南市',
        districts: [
          { name: '历下区', postalCode: '250014' },
          { name: '市中区', postalCode: '250001' },
          { name: '槐荫区', postalCode: '250117' },
          { name: '天桥区', postalCode: '250031' },
          { name: '历城区', postalCode: '250100' },
          { name: '长清区', postalCode: '250300' },
          { name: '章丘区', postalCode: '250200' },
          { name: '济阳区', postalCode: '251400' },
          { name: '莱芜区', postalCode: '271100' },
          { name: '钢城区', postalCode: '271100' },
        ]
      },
      {
        name: '青岛市',
        districts: [
          { name: '市南区', postalCode: '266001' },
          { name: '市北区', postalCode: '266011' },
          { name: '黄岛区', postalCode: '266500' },
          { name: '崂山区', postalCode: '266100' },
          { name: '李沧区', postalCode: '266021' },
          { name: '城阳区', postalCode: '266109' },
          { name: '即墨区', postalCode: '266200' },
          { name: '胶州市', postalCode: '266300' },
          { name: '平度市', postalCode: '266700' },
          { name: '莱西市', postalCode: '266600' },
        ]
      },
      {
        name: '烟台市',
        districts: [
          { name: '芝罘区', postalCode: '264001' },
          { name: '福山区', postalCode: '265500' },
          { name: '牟平区', postalCode: '264100' },
          { name: '莱山区', postalCode: '264003' },
          { name: '蓬莱区', postalCode: '265600' },
          { name: '龙口市', postalCode: '265700' },
          { name: '莱阳市', postalCode: '265200' },
          { name: '莱州市', postalCode: '261400' },
        ]
      },
      {
        name: '潍坊市',
        districts: [
          { name: '潍城区', postalCode: '261021' },
          { name: '寒亭区', postalCode: '261100' },
          { name: '坊子区', postalCode: '261200' },
          { name: '奎文区', postalCode: '261041' },
          { name: '临朐县', postalCode: '262600' },
          { name: '昌乐县', postalCode: '262400' },
          { name: '青州市', postalCode: '262500' },
          { name: '诸城市', postalCode: '262200' },
          { name: '寿光市', postalCode: '262700' },
          { name: '高密市', postalCode: '261500' },
        ]
      },
      {
        name: '威海市',
        districts: [
          { name: '环翠区', postalCode: '264200' },
          { name: '文登区', postalCode: '264400' },
          { name: '荣成市', postalCode: '264300' },
          { name: '乳山市', postalCode: '264500' },
        ]
      },
    ]
  },

  // 华中地区
  {
    name: '河南省',
    cities: [
      {
        name: '郑州市',
        districts: [
          { name: '中原区', postalCode: '450007' },
          { name: '二七区', postalCode: '450052' },
          { name: '管城回族区', postalCode: '450000' },
          { name: '金水区', postalCode: '450003' },
          { name: '上街区', postalCode: '450041' },
          { name: '惠济区', postalCode: '450053' },
          { name: '中牟县', postalCode: '451450' },
          { name: '巩义市', postalCode: '451200' },
          { name: '荥阳市', postalCode: '450100' },
          { name: '新密市', postalCode: '452370' },
          { name: '新郑市', postalCode: '451100' },
          { name: '登封市', postalCode: '452470' },
        ]
      },
      {
        name: '洛阳市',
        districts: [
          { name: '老城区', postalCode: '471002' },
          { name: '西工区', postalCode: '471000' },
          { name: '瀍河回族区', postalCode: '471002' },
          { name: '涧西区', postalCode: '471003' },
          { name: '洛龙区', postalCode: '471000' },
          { name: '偃师区', postalCode: '471900' },
          { name: '孟津区', postalCode: '471100' },
        ]
      },
      {
        name: '开封市',
        districts: [
          { name: '龙亭区', postalCode: '475100' },
          { name: '顺河回族区', postalCode: '475000' },
          { name: '鼓楼区', postalCode: '475000' },
          { name: '禹王台区', postalCode: '475003' },
          { name: '祥符区', postalCode: '475100' },
        ]
      },
      {
        name: '南阳市',
        districts: [
          { name: '宛城区', postalCode: '473001' },
          { name: '卧龙区', postalCode: '473003' },
          { name: '南召县', postalCode: '474650' },
          { name: '方城县', postalCode: '473200' },
          { name: '邓州市', postalCode: '474150' },
        ]
      },
    ]
  },
  {
    name: '湖北省',
    cities: [
      {
        name: '武汉市',
        districts: [
          { name: '江岸区', postalCode: '430014' },
          { name: '江汉区', postalCode: '430021' },
          { name: '硚口区', postalCode: '430033' },
          { name: '汉阳区', postalCode: '430050' },
          { name: '武昌区', postalCode: '430061' },
          { name: '青山区', postalCode: '430080' },
          { name: '洪山区', postalCode: '430070' },
          { name: '东西湖区', postalCode: '430040' },
          { name: '汉南区', postalCode: '430090' },
          { name: '蔡甸区', postalCode: '430100' },
          { name: '江夏区', postalCode: '430200' },
          { name: '黄陂区', postalCode: '432200' },
          { name: '新洲区', postalCode: '431400' },
        ]
      },
      {
        name: '宜昌市',
        districts: [
          { name: '西陵区', postalCode: '443000' },
          { name: '伍家岗区', postalCode: '443001' },
          { name: '点军区', postalCode: '443006' },
          { name: '猇亭区', postalCode: '443007' },
          { name: '夷陵区', postalCode: '443100' },
          { name: '宜都市', postalCode: '443300' },
          { name: '当阳市', postalCode: '444100' },
          { name: '枝江市', postalCode: '443200' },
        ]
      },
      {
        name: '襄阳市',
        districts: [
          { name: '襄城区', postalCode: '441021' },
          { name: '樊城区', postalCode: '441001' },
          { name: '襄州区', postalCode: '441100' },
          { name: '南漳县', postalCode: '441500' },
          { name: '谷城县', postalCode: '441700' },
          { name: '老河口市', postalCode: '441800' },
          { name: '枣阳市', postalCode: '441200' },
          { name: '宜城市', postalCode: '441400' },
        ]
      },
      {
        name: '荆州市',
        districts: [
          { name: '沙市区', postalCode: '434000' },
          { name: '荆州区', postalCode: '434020' },
          { name: '公安县', postalCode: '434300' },
          { name: '监利市', postalCode: '433300' },
          { name: '江陵县', postalCode: '434100' },
          { name: '石首市', postalCode: '434400' },
          { name: '洪湖市', postalCode: '433200' },
          { name: '松滋市', postalCode: '434200' },
        ]
      },
    ]
  },
  {
    name: '湖南省',
    cities: [
      {
        name: '长沙市',
        districts: [
          { name: '芙蓉区', postalCode: '410011' },
          { name: '天心区', postalCode: '410004' },
          { name: '岳麓区', postalCode: '410013' },
          { name: '开福区', postalCode: '410008' },
          { name: '雨花区', postalCode: '410011' },
          { name: '望城区', postalCode: '410200' },
          { name: '长沙县', postalCode: '410100' },
          { name: '浏阳市', postalCode: '410300' },
          { name: '宁乡市', postalCode: '410600' },
        ]
      },
      {
        name: '株洲市',
        districts: [
          { name: '荷塘区', postalCode: '412000' },
          { name: '芦淞区', postalCode: '412000' },
          { name: '石峰区', postalCode: '412005' },
          { name: '天元区', postalCode: '412007' },
          { name: '渌口区', postalCode: '412100' },
          { name: '醴陵市', postalCode: '412200' },
        ]
      },
      {
        name: '湘潭市',
        districts: [
          { name: '雨湖区', postalCode: '411100' },
          { name: '岳塘区', postalCode: '411101' },
          { name: '湘潭县', postalCode: '411228' },
          { name: '湘乡市', postalCode: '411400' },
          { name: '韶山市', postalCode: '411300' },
        ]
      },
      {
        name: '衡阳市',
        districts: [
          { name: '珠晖区', postalCode: '421002' },
          { name: '雁峰区', postalCode: '421001' },
          { name: '石鼓区', postalCode: '421005' },
          { name: '蒸湘区', postalCode: '421001' },
          { name: '南岳区', postalCode: '421900' },
          { name: '衡阳县', postalCode: '421200' },
          { name: '衡南县', postalCode: '421131' },
          { name: '衡山县', postalCode: '421300' },
          { name: '衡东县', postalCode: '421400' },
          { name: '耒阳市', postalCode: '421800' },
          { name: '常宁市', postalCode: '421500' },
        ]
      },
      {
        name: '岳阳市',
        districts: [
          { name: '岳阳楼区', postalCode: '414000' },
          { name: '云溪区', postalCode: '414009' },
          { name: '君山区', postalCode: '414005' },
          { name: '岳阳县', postalCode: '414100' },
          { name: '华容县', postalCode: '414200' },
          { name: '湘阴县', postalCode: '414600' },
          { name: '汨罗市', postalCode: '414400' },
          { name: '临湘市', postalCode: '414300' },
        ]
      },
      {
        name: '常德市',
        districts: [
          { name: '武陵区', postalCode: '415000' },
          { name: '鼎城区', postalCode: '415101' },
          { name: '安乡县', postalCode: '415600' },
          { name: '汉寿县', postalCode: '415900' },
          { name: '澧县', postalCode: '415500' },
          { name: '临澧县', postalCode: '415200' },
          { name: '桃源县', postalCode: '415700' },
          { name: '石门县', postalCode: '415300' },
          { name: '津市市', postalCode: '415400' },
        ]
      },
    ]
  },

  // 华南地区
  {
    name: '广东省',
    cities: [
      {
        name: '广州市',
        districts: [
          { name: '荔湾区', postalCode: '510140' },
          { name: '越秀区', postalCode: '510030' },
          { name: '海珠区', postalCode: '510220' },
          { name: '天河区', postalCode: '510630' },
          { name: '白云区', postalCode: '510080' },
          { name: '黄埔区', postalCode: '510700' },
          { name: '番禺区', postalCode: '511400' },
          { name: '花都区', postalCode: '510800' },
          { name: '南沙区', postalCode: '511458' },
          { name: '从化区', postalCode: '510900' },
          { name: '增城区', postalCode: '511300' },
        ]
      },
      {
        name: '深圳市',
        districts: [
          { name: '罗湖区', postalCode: '518001' },
          { name: '福田区', postalCode: '518048' },
          { name: '南山区', postalCode: '518051' },
          { name: '宝安区', postalCode: '518101' },
          { name: '龙岗区', postalCode: '518172' },
          { name: '盐田区', postalCode: '518081' },
          { name: '龙华区', postalCode: '518110' },
          { name: '坪山区', postalCode: '518118' },
          { name: '光明区', postalCode: '518107' },
        ]
      },
      {
        name: '珠海市',
        districts: [
          { name: '香洲区', postalCode: '519000' },
          { name: '斗门区', postalCode: '519100' },
          { name: '金湾区', postalCode: '519090' },
        ]
      },
      {
        name: '佛山市',
        districts: [
          { name: '禅城区', postalCode: '528000' },
          { name: '南海区', postalCode: '528200' },
          { name: '顺德区', postalCode: '528300' },
          { name: '三水区', postalCode: '528100' },
          { name: '高明区', postalCode: '528500' },
        ]
      },
      {
        name: '东莞市',
        districts: [
          { name: '莞城街道', postalCode: '523000' },
          { name: '南城街道', postalCode: '523073' },
          { name: '东城街道', postalCode: '523000' },
          { name: '万江街道', postalCode: '523039' },
          { name: '虎门镇', postalCode: '523900' },
          { name: '长安镇', postalCode: '523850' },
          { name: '厚街镇', postalCode: '523960' },
          { name: '塘厦镇', postalCode: '523710' },
          { name: '常平镇', postalCode: '523560' },
          { name: '凤岗镇', postalCode: '523690' },
        ]
      },
      {
        name: '中山市',
        districts: [
          { name: '石岐街道', postalCode: '528400' },
          { name: '东区街道', postalCode: '528403' },
          { name: '西区街道', postalCode: '528401' },
          { name: '南区街道', postalCode: '528400' },
          { name: '五桂山街道', postalCode: '528458' },
          { name: '小榄镇', postalCode: '528415' },
          { name: '古镇镇', postalCode: '528421' },
          { name: '横栏镇', postalCode: '528478' },
        ]
      },
      {
        name: '惠州市',
        districts: [
          { name: '惠城区', postalCode: '516001' },
          { name: '惠阳区', postalCode: '516211' },
          { name: '博罗县', postalCode: '516100' },
          { name: '惠东县', postalCode: '516300' },
          { name: '龙门县', postalCode: '516800' },
        ]
      },
      {
        name: '汕头市',
        districts: [
          { name: '龙湖区', postalCode: '515041' },
          { name: '金平区', postalCode: '515041' },
          { name: '濠江区', postalCode: '515071' },
          { name: '潮阳区', postalCode: '515100' },
          { name: '潮南区', postalCode: '515144' },
          { name: '澄海区', postalCode: '515800' },
        ]
      },
    ]
  },
  {
    name: '广西壮族自治区',
    cities: [
      {
        name: '南宁市',
        districts: [
          { name: '兴宁区', postalCode: '530023' },
          { name: '青秀区', postalCode: '530022' },
          { name: '江南区', postalCode: '530031' },
          { name: '西乡塘区', postalCode: '530001' },
          { name: '良庆区', postalCode: '530219' },
          { name: '邕宁区', postalCode: '530200' },
          { name: '武鸣区', postalCode: '530100' },
        ]
      },
      {
        name: '柳州市',
        districts: [
          { name: '城中区', postalCode: '545001' },
          { name: '鱼峰区', postalCode: '545005' },
          { name: '柳南区', postalCode: '545007' },
          { name: '柳北区', postalCode: '545002' },
          { name: '柳江区', postalCode: '545100' },
        ]
      },
      {
        name: '桂林市',
        districts: [
          { name: '秀峰区', postalCode: '541001' },
          { name: '叠彩区', postalCode: '541001' },
          { name: '象山区', postalCode: '541002' },
          { name: '七星区', postalCode: '541004' },
          { name: '雁山区', postalCode: '541006' },
          { name: '临桂区', postalCode: '541100' },
        ]
      },
    ]
  },
  {
    name: '海南省',
    cities: [
      {
        name: '海口市',
        districts: [
          { name: '秀英区', postalCode: '570311' },
          { name: '龙华区', postalCode: '570105' },
          { name: '琼山区', postalCode: '571100' },
          { name: '美兰区', postalCode: '570203' },
        ]
      },
      {
        name: '三亚市',
        districts: [
          { name: '海棠区', postalCode: '572013' },
          { name: '吉阳区', postalCode: '572000' },
          { name: '天涯区', postalCode: '572000' },
          { name: '崖州区', postalCode: '572022' },
        ]
      },
      {
        name: '三沙市',
        districts: [
          { name: '西沙区', postalCode: '573199' },
          { name: '南沙区', postalCode: '573199' },
        ]
      },
      {
        name: '儋州市',
        districts: [
          { name: '那大镇', postalCode: '571700' },
          { name: '和庆镇', postalCode: '571700' },
          { name: '南丰镇', postalCode: '571700' },
          { name: '大成镇', postalCode: '571700' },
        ]
      },
    ]
  },

  // 西南地区
  {
    name: '四川省',
    cities: [
      {
        name: '成都市',
        districts: [
          { name: '锦江区', postalCode: '610011' },
          { name: '青羊区', postalCode: '610031' },
          { name: '金牛区', postalCode: '610036' },
          { name: '武侯区', postalCode: '610041' },
          { name: '成华区', postalCode: '610066' },
          { name: '龙泉驿区', postalCode: '610100' },
          { name: '青白江区', postalCode: '610300' },
          { name: '新都区', postalCode: '610500' },
          { name: '温江区', postalCode: '611130' },
          { name: '双流区', postalCode: '610200' },
          { name: '郫都区', postalCode: '611730' },
          { name: '新津区', postalCode: '611430' },
          { name: '都江堰市', postalCode: '611830' },
          { name: '彭州市', postalCode: '611930' },
          { name: '邛崃市', postalCode: '611530' },
          { name: '崇州市', postalCode: '611230' },
          { name: '简阳市', postalCode: '641400' },
        ]
      },
      {
        name: '绵阳市',
        districts: [
          { name: '涪城区', postalCode: '621000' },
          { name: '游仙区', postalCode: '621022' },
          { name: '安州区', postalCode: '622650' },
          { name: '江油市', postalCode: '621700' },
        ]
      },
      {
        name: '德阳市',
        districts: [
          { name: '旌阳区', postalCode: '618000' },
          { name: '罗江区', postalCode: '618500' },
          { name: '广汉市', postalCode: '618300' },
          { name: '什邡市', postalCode: '618400' },
          { name: '绵竹市', postalCode: '618200' },
        ]
      },
      {
        name: '宜宾市',
        districts: [
          { name: '翠屏区', postalCode: '644000' },
          { name: '南溪区', postalCode: '644100' },
          { name: '叙州区', postalCode: '644600' },
          { name: '江安县', postalCode: '644200' },
        ]
      },
      {
        name: '泸州市',
        districts: [
          { name: '江阳区', postalCode: '646000' },
          { name: '纳溪区', postalCode: '646300' },
          { name: '龙马潭区', postalCode: '646000' },
          { name: '泸县', postalCode: '646100' },
          { name: '合江县', postalCode: '646200' },
        ]
      },
    ]
  },
  {
    name: '贵州省',
    cities: [
      {
        name: '贵阳市',
        districts: [
          { name: '南明区', postalCode: '550001' },
          { name: '云岩区', postalCode: '550001' },
          { name: '花溪区', postalCode: '550025' },
          { name: '乌当区', postalCode: '550018' },
          { name: '白云区', postalCode: '550014' },
          { name: '观山湖区', postalCode: '550081' },
          { name: '清镇市', postalCode: '551400' },
        ]
      },
      {
        name: '遵义市',
        districts: [
          { name: '红花岗区', postalCode: '563000' },
          { name: '汇川区', postalCode: '563003' },
          { name: '播州区', postalCode: '563100' },
          { name: '赤水市', postalCode: '564700' },
          { name: '仁怀市', postalCode: '564500' },
        ]
      },
      {
        name: '六盘水市',
        districts: [
          { name: '钟山区', postalCode: '553000' },
          { name: '六枝特区', postalCode: '553400' },
          { name: '水城区', postalCode: '553000' },
          { name: '盘州市', postalCode: '553500' },
        ]
      },
    ]
  },
  {
    name: '云南省',
    cities: [
      {
        name: '昆明市',
        districts: [
          { name: '五华区', postalCode: '650021' },
          { name: '盘龙区', postalCode: '650051' },
          { name: '官渡区', postalCode: '650200' },
          { name: '西山区', postalCode: '650118' },
          { name: '东川区', postalCode: '654100' },
          { name: '呈贡区', postalCode: '650500' },
          { name: '晋宁区', postalCode: '650600' },
          { name: '安宁市', postalCode: '650300' },
        ]
      },
      {
        name: '曲靖市',
        districts: [
          { name: '麒麟区', postalCode: '655000' },
          { name: '沾益区', postalCode: '655331' },
          { name: '马龙区', postalCode: '655100' },
          { name: '宣威市', postalCode: '655400' },
        ]
      },
      {
        name: '大理白族自治州',
        districts: [
          { name: '大理市', postalCode: '671000' },
          { name: '祥云县', postalCode: '672100' },
          { name: '宾川县', postalCode: '671600' },
          { name: '弥渡县', postalCode: '675600' },
        ]
      },
      {
        name: '丽江市',
        districts: [
          { name: '古城区', postalCode: '674100' },
          { name: '玉龙纳西族自治县', postalCode: '674100' },
          { name: '永胜县', postalCode: '674200' },
          { name: '华坪县', postalCode: '674800' },
        ]
      },
    ]
  },
  {
    name: '西藏自治区',
    cities: [
      {
        name: '拉萨市',
        districts: [
          { name: '城关区', postalCode: '850000' },
          { name: '堆龙德庆区', postalCode: '851400' },
          { name: '达孜区', postalCode: '850100' },
          { name: '林周县', postalCode: '851600' },
          { name: '当雄县', postalCode: '851500' },
        ]
      },
      {
        name: '日喀则市',
        districts: [
          { name: '桑珠孜区', postalCode: '857000' },
          { name: '南木林县', postalCode: '857100' },
          { name: '江孜县', postalCode: '857400' },
          { name: '定日县', postalCode: '858200' },
        ]
      },
    ]
  },

  // 西北地区
  {
    name: '陕西省',
    cities: [
      {
        name: '西安市',
        districts: [
          { name: '新城区', postalCode: '710004' },
          { name: '碑林区', postalCode: '710001' },
          { name: '莲湖区', postalCode: '710003' },
          { name: '灞桥区', postalCode: '710038' },
          { name: '未央区', postalCode: '710016' },
          { name: '雁塔区', postalCode: '710061' },
          { name: '阎良区', postalCode: '710089' },
          { name: '临潼区', postalCode: '710600' },
          { name: '长安区', postalCode: '710100' },
          { name: '高陵区', postalCode: '710200' },
          { name: '鄠邑区', postalCode: '710300' },
        ]
      },
      {
        name: '咸阳市',
        districts: [
          { name: '秦都区', postalCode: '712000' },
          { name: '杨陵区', postalCode: '712100' },
          { name: '渭城区', postalCode: '712000' },
          { name: '兴平市', postalCode: '713100' },
        ]
      },
      {
        name: '宝鸡市',
        districts: [
          { name: '渭滨区', postalCode: '721000' },
          { name: '金台区', postalCode: '721000' },
          { name: '陈仓区', postalCode: '721300' },
          { name: '凤翔区', postalCode: '721400' },
        ]
      },
      {
        name: '延安市',
        districts: [
          { name: '宝塔区', postalCode: '716000' },
          { name: '安塞区', postalCode: '717400' },
          { name: '延长县', postalCode: '717100' },
          { name: '延川县', postalCode: '717200' },
        ]
      },
    ]
  },
  {
    name: '甘肃省',
    cities: [
      {
        name: '兰州市',
        districts: [
          { name: '城关区', postalCode: '730030' },
          { name: '七里河区', postalCode: '730050' },
          { name: '西固区', postalCode: '730060' },
          { name: '安宁区', postalCode: '730070' },
          { name: '红古区', postalCode: '730084' },
        ]
      },
      {
        name: '天水市',
        districts: [
          { name: '秦州区', postalCode: '741000' },
          { name: '麦积区', postalCode: '741020' },
          { name: '清水县', postalCode: '741400' },
          { name: '秦安县', postalCode: '741600' },
        ]
      },
      {
        name: '酒泉市',
        districts: [
          { name: '肃州区', postalCode: '735000' },
          { name: '金塔县', postalCode: '735300' },
          { name: '瓜州县', postalCode: '736100' },
          { name: '敦煌市', postalCode: '736200' },
        ]
      },
    ]
  },
  {
    name: '青海省',
    cities: [
      {
        name: '西宁市',
        districts: [
          { name: '城东区', postalCode: '810007' },
          { name: '城中区', postalCode: '810000' },
          { name: '城西区', postalCode: '810001' },
          { name: '城北区', postalCode: '810003' },
          { name: '湟中区', postalCode: '811600' },
          { name: '湟源县', postalCode: '812100' },
        ]
      },
      {
        name: '海东市',
        districts: [
          { name: '乐都区', postalCode: '810700' },
          { name: '平安区', postalCode: '810600' },
          { name: '民和回族土族自治县', postalCode: '810800' },
          { name: '互助土族自治县', postalCode: '810500' },
        ]
      },
    ]
  },
  {
    name: '宁夏回族自治区',
    cities: [
      {
        name: '银川市',
        districts: [
          { name: '兴庆区', postalCode: '750001' },
          { name: '西夏区', postalCode: '750021' },
          { name: '金凤区', postalCode: '750011' },
          { name: '永宁县', postalCode: '750100' },
          { name: '贺兰县', postalCode: '750200' },
          { name: '灵武市', postalCode: '751400' },
        ]
      },
      {
        name: '石嘴山市',
        districts: [
          { name: '大武口区', postalCode: '753000' },
          { name: '惠农区', postalCode: '753600' },
          { name: '平罗县', postalCode: '753400' },
        ]
      },
      {
        name: '吴忠市',
        districts: [
          { name: '利通区', postalCode: '751100' },
          { name: '红寺堡区', postalCode: '751900' },
          { name: '盐池县', postalCode: '751500' },
          { name: '同心县', postalCode: '751300' },
          { name: '青铜峡市', postalCode: '751600' },
        ]
      },
    ]
  },
  {
    name: '新疆维吾尔自治区',
    cities: [
      {
        name: '乌鲁木齐市',
        districts: [
          { name: '天山区', postalCode: '830002' },
          { name: '沙依巴克区', postalCode: '830000' },
          { name: '新市区', postalCode: '830011' },
          { name: '水磨沟区', postalCode: '830017' },
          { name: '头屯河区', postalCode: '830022' },
          { name: '达坂城区', postalCode: '830039' },
          { name: '米东区', postalCode: '831400' },
        ]
      },
      {
        name: '克拉玛依市',
        districts: [
          { name: '独山子区', postalCode: '833600' },
          { name: '克拉玛依区', postalCode: '834000' },
          { name: '白碱滩区', postalCode: '834008' },
          { name: '乌尔禾区', postalCode: '834012' },
        ]
      },
      {
        name: '吐鲁番市',
        districts: [
          { name: '高昌区', postalCode: '838000' },
          { name: '鄯善县', postalCode: '838200' },
          { name: '托克逊县', postalCode: '838100' },
        ]
      },
      {
        name: '喀什地区',
        districts: [
          { name: '喀什市', postalCode: '844000' },
          { name: '疏附县', postalCode: '844100' },
          { name: '疏勒县', postalCode: '844200' },
          { name: '英吉沙县', postalCode: '844500' },
        ]
      },
    ]
  },
];


// ==================== 海外地址数据 ====================

// 通用海外地址结构
export interface OverseasDistrict {
  name: string;
  postalCode: string;
}

export interface OverseasCity {
  name: string;
  districts: OverseasDistrict[];
}

export interface OverseasState {
  name: string;
  cities: OverseasCity[];
}

export interface OverseasCountry {
  name: string;
  code: string;
  states: OverseasState[];
  postalCodeFormat: string; // 邮编格式说明
  streetFormats: string[]; // 街道名称格式
  addressLine2Formats: string[]; // 地址第二行格式
}

// 美国地址数据
export const usaAddressData: OverseasCountry = {
  name: '美国',
  code: 'US',
  postalCodeFormat: '5位数字',
  streetFormats: [
    '{number} Main Street',
    '{number} Oak Avenue',
    '{number} Maple Drive',
    '{number} Cedar Lane',
    '{number} Pine Road',
    '{number} Elm Street',
    '{number} Washington Boulevard',
    '{number} Lincoln Avenue',
    '{number} Park Place',
    '{number} Broadway',
    '{number} Market Street',
    '{number} Church Street',
    '{number} High Street',
    '{number} Mill Road',
    '{number} River Road',
  ],
  addressLine2Formats: [
    'Apt {apt}',
    'Suite {apt}',
    'Unit {apt}',
    'Floor {floor}',
    'Building {building}',
    '#APT {apt}',
  ],
  states: [
    {
      name: 'California',
      cities: [
        {
          name: 'Los Angeles',
          districts: [
            { name: 'Downtown', postalCode: '90012' },
            { name: 'Hollywood', postalCode: '90028' },
            { name: 'Beverly Hills', postalCode: '90210' },
            { name: 'Santa Monica', postalCode: '90401' },
            { name: 'Venice', postalCode: '90291' },
            { name: 'Westwood', postalCode: '90024' },
            { name: 'Koreatown', postalCode: '90005' },
            { name: 'Silver Lake', postalCode: '90026' },
          ]
        },
        {
          name: 'San Francisco',
          districts: [
            { name: 'Financial District', postalCode: '94111' },
            { name: 'Mission District', postalCode: '94110' },
            { name: 'SoMa', postalCode: '94103' },
            { name: 'Chinatown', postalCode: '94108' },
            { name: 'North Beach', postalCode: '94133' },
            { name: 'Marina District', postalCode: '94123' },
            { name: 'Pacific Heights', postalCode: '94115' },
          ]
        },
        {
          name: 'San Diego',
          districts: [
            { name: 'Downtown', postalCode: '92101' },
            { name: 'La Jolla', postalCode: '92037' },
            { name: 'Pacific Beach', postalCode: '92109' },
            { name: 'Gaslamp Quarter', postalCode: '92101' },
            { name: 'Mission Valley', postalCode: '92108' },
          ]
        },
        {
          name: 'San Jose',
          districts: [
            { name: 'Downtown', postalCode: '95113' },
            { name: 'Willow Glen', postalCode: '95125' },
            { name: 'Almaden Valley', postalCode: '95120' },
            { name: 'Evergreen', postalCode: '95148' },
          ]
        },
      ]
    },
    {
      name: 'New York',
      cities: [
        {
          name: 'New York City',
          districts: [
            { name: 'Manhattan', postalCode: '10001' },
            { name: 'Brooklyn', postalCode: '11201' },
            { name: 'Queens', postalCode: '11101' },
            { name: 'Bronx', postalCode: '10451' },
            { name: 'Staten Island', postalCode: '10301' },
            { name: 'Midtown', postalCode: '10019' },
            { name: 'Upper East Side', postalCode: '10021' },
            { name: 'Upper West Side', postalCode: '10024' },
            { name: 'SoHo', postalCode: '10012' },
            { name: 'Tribeca', postalCode: '10013' },
            { name: 'Chelsea', postalCode: '10011' },
            { name: 'Harlem', postalCode: '10027' },
          ]
        },
        {
          name: 'Buffalo',
          districts: [
            { name: 'Downtown', postalCode: '14202' },
            { name: 'Elmwood Village', postalCode: '14222' },
            { name: 'North Buffalo', postalCode: '14216' },
          ]
        },
      ]
    },
    {
      name: 'Texas',
      cities: [
        {
          name: 'Houston',
          districts: [
            { name: 'Downtown', postalCode: '77002' },
            { name: 'Midtown', postalCode: '77006' },
            { name: 'Galleria', postalCode: '77056' },
            { name: 'Heights', postalCode: '77008' },
            { name: 'Montrose', postalCode: '77006' },
            { name: 'River Oaks', postalCode: '77019' },
          ]
        },
        {
          name: 'Dallas',
          districts: [
            { name: 'Downtown', postalCode: '75201' },
            { name: 'Uptown', postalCode: '75204' },
            { name: 'Deep Ellum', postalCode: '75226' },
            { name: 'Oak Lawn', postalCode: '75219' },
            { name: 'Highland Park', postalCode: '75205' },
          ]
        },
        {
          name: 'Austin',
          districts: [
            { name: 'Downtown', postalCode: '78701' },
            { name: 'South Congress', postalCode: '78704' },
            { name: 'East Austin', postalCode: '78702' },
            { name: 'Hyde Park', postalCode: '78751' },
            { name: 'Zilker', postalCode: '78704' },
          ]
        },
        {
          name: 'San Antonio',
          districts: [
            { name: 'Downtown', postalCode: '78205' },
            { name: 'Alamo Heights', postalCode: '78209' },
            { name: 'Stone Oak', postalCode: '78258' },
            { name: 'Southtown', postalCode: '78204' },
          ]
        },
      ]
    },
    {
      name: 'Florida',
      cities: [
        {
          name: 'Miami',
          districts: [
            { name: 'Downtown', postalCode: '33131' },
            { name: 'South Beach', postalCode: '33139' },
            { name: 'Brickell', postalCode: '33131' },
            { name: 'Wynwood', postalCode: '33127' },
            { name: 'Coral Gables', postalCode: '33134' },
            { name: 'Coconut Grove', postalCode: '33133' },
          ]
        },
        {
          name: 'Orlando',
          districts: [
            { name: 'Downtown', postalCode: '32801' },
            { name: 'Winter Park', postalCode: '32789' },
            { name: 'Lake Nona', postalCode: '32827' },
            { name: 'Dr. Phillips', postalCode: '32819' },
          ]
        },
        {
          name: 'Tampa',
          districts: [
            { name: 'Downtown', postalCode: '33602' },
            { name: 'Ybor City', postalCode: '33605' },
            { name: 'Hyde Park', postalCode: '33606' },
            { name: 'Channelside', postalCode: '33602' },
          ]
        },
      ]
    },
    {
      name: 'Washington',
      cities: [
        {
          name: 'Seattle',
          districts: [
            { name: 'Downtown', postalCode: '98101' },
            { name: 'Capitol Hill', postalCode: '98102' },
            { name: 'Ballard', postalCode: '98107' },
            { name: 'Fremont', postalCode: '98103' },
            { name: 'Queen Anne', postalCode: '98109' },
            { name: 'University District', postalCode: '98105' },
            { name: 'South Lake Union', postalCode: '98109' },
          ]
        },
        {
          name: 'Bellevue',
          districts: [
            { name: 'Downtown', postalCode: '98004' },
            { name: 'Crossroads', postalCode: '98008' },
            { name: 'Factoria', postalCode: '98006' },
          ]
        },
      ]
    },
    {
      name: 'Illinois',
      cities: [
        {
          name: 'Chicago',
          districts: [
            { name: 'Loop', postalCode: '60601' },
            { name: 'River North', postalCode: '60654' },
            { name: 'Lincoln Park', postalCode: '60614' },
            { name: 'Wicker Park', postalCode: '60622' },
            { name: 'Gold Coast', postalCode: '60610' },
            { name: 'Lakeview', postalCode: '60657' },
            { name: 'Hyde Park', postalCode: '60615' },
          ]
        },
      ]
    },
    {
      name: 'Massachusetts',
      cities: [
        {
          name: 'Boston',
          districts: [
            { name: 'Downtown', postalCode: '02108' },
            { name: 'Back Bay', postalCode: '02116' },
            { name: 'Beacon Hill', postalCode: '02108' },
            { name: 'South End', postalCode: '02118' },
            { name: 'Cambridge', postalCode: '02139' },
            { name: 'Somerville', postalCode: '02143' },
          ]
        },
      ]
    },
    {
      name: 'Georgia',
      cities: [
        {
          name: 'Atlanta',
          districts: [
            { name: 'Downtown', postalCode: '30303' },
            { name: 'Midtown', postalCode: '30309' },
            { name: 'Buckhead', postalCode: '30305' },
            { name: 'Virginia-Highland', postalCode: '30306' },
            { name: 'Decatur', postalCode: '30030' },
          ]
        },
      ]
    },
  ]
};


// 英国地址数据
export const ukAddressData: OverseasCountry = {
  name: '英国',
  code: 'UK',
  postalCodeFormat: '字母数字组合 (如 SW1A 1AA)',
  streetFormats: [
    '{number} High Street',
    '{number} Church Road',
    '{number} Station Road',
    '{number} London Road',
    '{number} Park Road',
    '{number} Victoria Street',
    '{number} Queen Street',
    '{number} King Street',
    '{number} Oxford Street',
    '{number} Regent Street',
    '{number} Baker Street',
    '{number} Abbey Road',
    '{number} Piccadilly',
  ],
  addressLine2Formats: [
    'Flat {apt}',
    'Unit {apt}',
    'Floor {floor}',
    'Suite {apt}',
  ],
  states: [
    {
      name: 'England',
      cities: [
        {
          name: 'London',
          districts: [
            { name: 'Westminster', postalCode: 'SW1A 1AA' },
            { name: 'City of London', postalCode: 'EC1A 1BB' },
            { name: 'Camden', postalCode: 'NW1 0NE' },
            { name: 'Kensington', postalCode: 'W8 4PL' },
            { name: 'Chelsea', postalCode: 'SW3 4LY' },
            { name: 'Islington', postalCode: 'N1 0UU' },
            { name: 'Hackney', postalCode: 'E8 1DY' },
            { name: 'Greenwich', postalCode: 'SE10 8EW' },
            { name: 'Southwark', postalCode: 'SE1 7PB' },
            { name: 'Tower Hamlets', postalCode: 'E1 6AN' },
          ]
        },
        {
          name: 'Manchester',
          districts: [
            { name: 'City Centre', postalCode: 'M1 1AD' },
            { name: 'Salford', postalCode: 'M3 5BQ' },
            { name: 'Didsbury', postalCode: 'M20 2DW' },
            { name: 'Chorlton', postalCode: 'M21 9NQ' },
            { name: 'Northern Quarter', postalCode: 'M4 1HQ' },
          ]
        },
        {
          name: 'Birmingham',
          districts: [
            { name: 'City Centre', postalCode: 'B1 1BB' },
            { name: 'Edgbaston', postalCode: 'B15 3ES' },
            { name: 'Moseley', postalCode: 'B13 8JP' },
            { name: 'Harborne', postalCode: 'B17 9NT' },
          ]
        },
        {
          name: 'Liverpool',
          districts: [
            { name: 'City Centre', postalCode: 'L1 1JD' },
            { name: 'Albert Dock', postalCode: 'L3 4AF' },
            { name: 'Anfield', postalCode: 'L4 0TH' },
            { name: 'Toxteth', postalCode: 'L8 0SY' },
          ]
        },
        {
          name: 'Bristol',
          districts: [
            { name: 'City Centre', postalCode: 'BS1 1AA' },
            { name: 'Clifton', postalCode: 'BS8 1AA' },
            { name: 'Harbourside', postalCode: 'BS1 5TX' },
            { name: 'Redland', postalCode: 'BS6 6AA' },
          ]
        },
        {
          name: 'Leeds',
          districts: [
            { name: 'City Centre', postalCode: 'LS1 1AA' },
            { name: 'Headingley', postalCode: 'LS6 1AA' },
            { name: 'Chapel Allerton', postalCode: 'LS7 3AA' },
          ]
        },
      ]
    },
    {
      name: 'Scotland',
      cities: [
        {
          name: 'Edinburgh',
          districts: [
            { name: 'Old Town', postalCode: 'EH1 1RE' },
            { name: 'New Town', postalCode: 'EH2 2AF' },
            { name: 'Leith', postalCode: 'EH6 6AA' },
            { name: 'Stockbridge', postalCode: 'EH3 5AA' },
            { name: 'Morningside', postalCode: 'EH10 4AA' },
          ]
        },
        {
          name: 'Glasgow',
          districts: [
            { name: 'City Centre', postalCode: 'G1 1AA' },
            { name: 'West End', postalCode: 'G12 8AA' },
            { name: 'Merchant City', postalCode: 'G1 1PQ' },
            { name: 'Finnieston', postalCode: 'G3 8AA' },
          ]
        },
      ]
    },
    {
      name: 'Wales',
      cities: [
        {
          name: 'Cardiff',
          districts: [
            { name: 'City Centre', postalCode: 'CF10 1AA' },
            { name: 'Cardiff Bay', postalCode: 'CF10 5AL' },
            { name: 'Cathays', postalCode: 'CF24 4AA' },
            { name: 'Roath', postalCode: 'CF23 5AA' },
          ]
        },
      ]
    },
  ]
};

// 日本地址数据
export const japanAddressData: OverseasCountry = {
  name: '日本',
  code: 'JP',
  postalCodeFormat: '3位-4位数字 (如 100-0001)',
  streetFormats: [
    '{chome}-{ban}-{go}',
  ],
  addressLine2Formats: [
    '{building}マンション {room}号室',
    '{building}ビル {floor}F',
    '{building}アパート {room}号',
  ],
  states: [
    {
      name: '東京都',
      cities: [
        {
          name: '千代田区',
          districts: [
            { name: '丸の内', postalCode: '100-0005' },
            { name: '大手町', postalCode: '100-0004' },
            { name: '霞が関', postalCode: '100-0013' },
            { name: '永田町', postalCode: '100-0014' },
            { name: '秋葉原', postalCode: '101-0021' },
          ]
        },
        {
          name: '中央区',
          districts: [
            { name: '銀座', postalCode: '104-0061' },
            { name: '日本橋', postalCode: '103-0027' },
            { name: '築地', postalCode: '104-0045' },
            { name: '八丁堀', postalCode: '104-0032' },
          ]
        },
        {
          name: '港区',
          districts: [
            { name: '六本木', postalCode: '106-0032' },
            { name: '赤坂', postalCode: '107-0052' },
            { name: '青山', postalCode: '107-0062' },
            { name: '麻布', postalCode: '106-0046' },
            { name: '品川', postalCode: '108-0075' },
            { name: '台場', postalCode: '135-0091' },
          ]
        },
        {
          name: '新宿区',
          districts: [
            { name: '新宿', postalCode: '160-0022' },
            { name: '歌舞伎町', postalCode: '160-0021' },
            { name: '高田馬場', postalCode: '169-0075' },
            { name: '早稲田', postalCode: '162-0042' },
          ]
        },
        {
          name: '渋谷区',
          districts: [
            { name: '渋谷', postalCode: '150-0002' },
            { name: '原宿', postalCode: '150-0001' },
            { name: '恵比寿', postalCode: '150-0013' },
            { name: '代官山', postalCode: '150-0034' },
            { name: '表参道', postalCode: '150-0001' },
          ]
        },
        {
          name: '豊島区',
          districts: [
            { name: '池袋', postalCode: '171-0021' },
            { name: '巣鴨', postalCode: '170-0002' },
            { name: '目白', postalCode: '171-0031' },
          ]
        },
        {
          name: '世田谷区',
          districts: [
            { name: '三軒茶屋', postalCode: '154-0024' },
            { name: '下北沢', postalCode: '155-0031' },
            { name: '二子玉川', postalCode: '158-0094' },
            { name: '成城', postalCode: '157-0066' },
          ]
        },
      ]
    },
    {
      name: '大阪府',
      cities: [
        {
          name: '大阪市北区',
          districts: [
            { name: '梅田', postalCode: '530-0001' },
            { name: '中之島', postalCode: '530-0005' },
            { name: '天神橋', postalCode: '530-0041' },
          ]
        },
        {
          name: '大阪市中央区',
          districts: [
            { name: '心斎橋', postalCode: '542-0085' },
            { name: '難波', postalCode: '542-0076' },
            { name: '本町', postalCode: '541-0053' },
            { name: '道頓堀', postalCode: '542-0071' },
          ]
        },
        {
          name: '大阪市天王寺区',
          districts: [
            { name: '天王寺', postalCode: '543-0055' },
            { name: '上本町', postalCode: '543-0001' },
          ]
        },
      ]
    },
    {
      name: '神奈川県',
      cities: [
        {
          name: '横浜市中区',
          districts: [
            { name: '関内', postalCode: '231-0012' },
            { name: '元町', postalCode: '231-0861' },
            { name: '山下町', postalCode: '231-0023' },
            { name: '中華街', postalCode: '231-0023' },
          ]
        },
        {
          name: '横浜市西区',
          districts: [
            { name: 'みなとみらい', postalCode: '220-0012' },
            { name: '横浜駅', postalCode: '220-0005' },
          ]
        },
        {
          name: '川崎市川崎区',
          districts: [
            { name: '川崎駅', postalCode: '210-0007' },
            { name: '小川町', postalCode: '210-0023' },
          ]
        },
      ]
    },
    {
      name: '愛知県',
      cities: [
        {
          name: '名古屋市中区',
          districts: [
            { name: '栄', postalCode: '460-0008' },
            { name: '大須', postalCode: '460-0011' },
            { name: '錦', postalCode: '460-0003' },
          ]
        },
        {
          name: '名古屋市中村区',
          districts: [
            { name: '名駅', postalCode: '450-0002' },
            { name: '太閤', postalCode: '453-0801' },
          ]
        },
      ]
    },
    {
      name: '京都府',
      cities: [
        {
          name: '京都市中京区',
          districts: [
            { name: '河原町', postalCode: '604-8005' },
            { name: '烏丸', postalCode: '604-8156' },
            { name: '二条', postalCode: '604-8301' },
          ]
        },
        {
          name: '京都市東山区',
          districts: [
            { name: '祇園', postalCode: '605-0073' },
            { name: '清水', postalCode: '605-0862' },
          ]
        },
      ]
    },
    {
      name: '福岡県',
      cities: [
        {
          name: '福岡市博多区',
          districts: [
            { name: '博多駅', postalCode: '812-0012' },
            { name: '中洲', postalCode: '812-0026' },
            { name: '祇園', postalCode: '812-0038' },
          ]
        },
        {
          name: '福岡市中央区',
          districts: [
            { name: '天神', postalCode: '810-0001' },
            { name: '大名', postalCode: '810-0041' },
            { name: '薬院', postalCode: '810-0022' },
          ]
        },
      ]
    },
  ]
};


// 加拿大地址数据
export const canadaAddressData: OverseasCountry = {
  name: '加拿大',
  code: 'CA',
  postalCodeFormat: '字母数字组合 (如 M5V 3L9)',
  streetFormats: [
    '{number} Main Street',
    '{number} King Street',
    '{number} Queen Street',
    '{number} Yonge Street',
    '{number} Bay Street',
    '{number} Bloor Street',
    '{number} Dundas Street',
    '{number} College Street',
    '{number} Granville Street',
    '{number} Robson Street',
  ],
  addressLine2Formats: [
    'Unit {apt}',
    'Suite {apt}',
    'Apt {apt}',
    'Floor {floor}',
  ],
  states: [
    {
      name: 'Ontario',
      cities: [
        {
          name: 'Toronto',
          districts: [
            { name: 'Downtown', postalCode: 'M5V 3L9' },
            { name: 'North York', postalCode: 'M2N 6K8' },
            { name: 'Scarborough', postalCode: 'M1P 4P5' },
            { name: 'Etobicoke', postalCode: 'M9C 5K1' },
            { name: 'Yorkville', postalCode: 'M5R 1B8' },
            { name: 'The Annex', postalCode: 'M5R 2G2' },
            { name: 'Liberty Village', postalCode: 'M6K 3P6' },
          ]
        },
        {
          name: 'Ottawa',
          districts: [
            { name: 'Downtown', postalCode: 'K1P 5G3' },
            { name: 'Byward Market', postalCode: 'K1N 7B7' },
            { name: 'Glebe', postalCode: 'K1S 2C9' },
            { name: 'Westboro', postalCode: 'K1Z 5L5' },
          ]
        },
        {
          name: 'Mississauga',
          districts: [
            { name: 'City Centre', postalCode: 'L5B 3C2' },
            { name: 'Port Credit', postalCode: 'L5G 4M3' },
            { name: 'Streetsville', postalCode: 'L5M 1M2' },
          ]
        },
      ]
    },
    {
      name: 'British Columbia',
      cities: [
        {
          name: 'Vancouver',
          districts: [
            { name: 'Downtown', postalCode: 'V6C 3L6' },
            { name: 'Gastown', postalCode: 'V6B 1B9' },
            { name: 'Yaletown', postalCode: 'V6Z 2Y3' },
            { name: 'Kitsilano', postalCode: 'V6K 2B5' },
            { name: 'West End', postalCode: 'V6E 1M3' },
            { name: 'Coal Harbour', postalCode: 'V6C 3E8' },
          ]
        },
        {
          name: 'Victoria',
          districts: [
            { name: 'Downtown', postalCode: 'V8W 1N3' },
            { name: 'James Bay', postalCode: 'V8V 1X4' },
            { name: 'Oak Bay', postalCode: 'V8R 1E3' },
          ]
        },
      ]
    },
    {
      name: 'Quebec',
      cities: [
        {
          name: 'Montreal',
          districts: [
            { name: 'Downtown', postalCode: 'H3B 4G5' },
            { name: 'Old Montreal', postalCode: 'H2Y 1C6' },
            { name: 'Plateau Mont-Royal', postalCode: 'H2W 1R7' },
            { name: 'Mile End', postalCode: 'H2T 2A3' },
            { name: 'Griffintown', postalCode: 'H3C 0G3' },
          ]
        },
        {
          name: 'Quebec City',
          districts: [
            { name: 'Old Quebec', postalCode: 'G1R 4P5' },
            { name: 'Saint-Roch', postalCode: 'G1K 3B9' },
            { name: 'Sainte-Foy', postalCode: 'G1V 4G5' },
          ]
        },
      ]
    },
    {
      name: 'Alberta',
      cities: [
        {
          name: 'Calgary',
          districts: [
            { name: 'Downtown', postalCode: 'T2P 3N4' },
            { name: 'Beltline', postalCode: 'T2R 0E7' },
            { name: 'Kensington', postalCode: 'T2N 3Z9' },
            { name: 'Mission', postalCode: 'T2G 1A5' },
          ]
        },
        {
          name: 'Edmonton',
          districts: [
            { name: 'Downtown', postalCode: 'T5J 0N3' },
            { name: 'Old Strathcona', postalCode: 'T6E 1Z8' },
            { name: 'Whyte Avenue', postalCode: 'T6E 2A2' },
          ]
        },
      ]
    },
  ]
};

// 澳大利亚地址数据
export const australiaAddressData: OverseasCountry = {
  name: '澳大利亚',
  code: 'AU',
  postalCodeFormat: '4位数字',
  streetFormats: [
    '{number} George Street',
    '{number} Pitt Street',
    '{number} Collins Street',
    '{number} Bourke Street',
    '{number} Queen Street',
    '{number} Adelaide Street',
    '{number} Elizabeth Street',
    '{number} Flinders Street',
    '{number} King Street',
    '{number} William Street',
  ],
  addressLine2Formats: [
    'Unit {apt}',
    'Suite {apt}',
    'Level {floor}',
    'Apt {apt}',
  ],
  states: [
    {
      name: 'New South Wales',
      cities: [
        {
          name: 'Sydney',
          districts: [
            { name: 'CBD', postalCode: '2000' },
            { name: 'Surry Hills', postalCode: '2010' },
            { name: 'Darlinghurst', postalCode: '2010' },
            { name: 'Bondi', postalCode: '2026' },
            { name: 'Newtown', postalCode: '2042' },
            { name: 'Paddington', postalCode: '2021' },
            { name: 'Pyrmont', postalCode: '2009' },
            { name: 'Manly', postalCode: '2095' },
          ]
        },
        {
          name: 'Newcastle',
          districts: [
            { name: 'CBD', postalCode: '2300' },
            { name: 'Hamilton', postalCode: '2303' },
            { name: 'Merewether', postalCode: '2291' },
          ]
        },
      ]
    },
    {
      name: 'Victoria',
      cities: [
        {
          name: 'Melbourne',
          districts: [
            { name: 'CBD', postalCode: '3000' },
            { name: 'Southbank', postalCode: '3006' },
            { name: 'South Yarra', postalCode: '3141' },
            { name: 'St Kilda', postalCode: '3182' },
            { name: 'Fitzroy', postalCode: '3065' },
            { name: 'Carlton', postalCode: '3053' },
            { name: 'Richmond', postalCode: '3121' },
            { name: 'Docklands', postalCode: '3008' },
          ]
        },
      ]
    },
    {
      name: 'Queensland',
      cities: [
        {
          name: 'Brisbane',
          districts: [
            { name: 'CBD', postalCode: '4000' },
            { name: 'South Bank', postalCode: '4101' },
            { name: 'Fortitude Valley', postalCode: '4006' },
            { name: 'West End', postalCode: '4101' },
            { name: 'New Farm', postalCode: '4005' },
          ]
        },
        {
          name: 'Gold Coast',
          districts: [
            { name: 'Surfers Paradise', postalCode: '4217' },
            { name: 'Broadbeach', postalCode: '4218' },
            { name: 'Southport', postalCode: '4215' },
          ]
        },
      ]
    },
    {
      name: 'Western Australia',
      cities: [
        {
          name: 'Perth',
          districts: [
            { name: 'CBD', postalCode: '6000' },
            { name: 'Northbridge', postalCode: '6003' },
            { name: 'Subiaco', postalCode: '6008' },
            { name: 'Fremantle', postalCode: '6160' },
            { name: 'Leederville', postalCode: '6007' },
          ]
        },
      ]
    },
    {
      name: 'South Australia',
      cities: [
        {
          name: 'Adelaide',
          districts: [
            { name: 'CBD', postalCode: '5000' },
            { name: 'North Adelaide', postalCode: '5006' },
            { name: 'Glenelg', postalCode: '5045' },
            { name: 'Norwood', postalCode: '5067' },
          ]
        },
      ]
    },
  ]
};

// 德国地址数据
export const germanyAddressData: OverseasCountry = {
  name: '德国',
  code: 'DE',
  postalCodeFormat: '5位数字',
  streetFormats: [
    'Hauptstraße {number}',
    'Bahnhofstraße {number}',
    'Schulstraße {number}',
    'Gartenstraße {number}',
    'Berliner Straße {number}',
    'Friedrichstraße {number}',
    'Königstraße {number}',
    'Marktplatz {number}',
    'Lindenstraße {number}',
    'Kirchstraße {number}',
  ],
  addressLine2Formats: [
    'Wohnung {apt}',
    'Etage {floor}',
    'Apartment {apt}',
  ],
  states: [
    {
      name: 'Berlin',
      cities: [
        {
          name: 'Berlin',
          districts: [
            { name: 'Mitte', postalCode: '10115' },
            { name: 'Prenzlauer Berg', postalCode: '10405' },
            { name: 'Kreuzberg', postalCode: '10961' },
            { name: 'Friedrichshain', postalCode: '10243' },
            { name: 'Charlottenburg', postalCode: '10585' },
            { name: 'Neukölln', postalCode: '12043' },
            { name: 'Schöneberg', postalCode: '10777' },
          ]
        },
      ]
    },
    {
      name: 'Bayern',
      cities: [
        {
          name: 'München',
          districts: [
            { name: 'Altstadt', postalCode: '80331' },
            { name: 'Schwabing', postalCode: '80799' },
            { name: 'Maxvorstadt', postalCode: '80333' },
            { name: 'Haidhausen', postalCode: '81667' },
            { name: 'Sendling', postalCode: '81369' },
          ]
        },
        {
          name: 'Nürnberg',
          districts: [
            { name: 'Altstadt', postalCode: '90403' },
            { name: 'St. Johannis', postalCode: '90419' },
            { name: 'Gostenhof', postalCode: '90429' },
          ]
        },
      ]
    },
    {
      name: 'Hamburg',
      cities: [
        {
          name: 'Hamburg',
          districts: [
            { name: 'Altstadt', postalCode: '20095' },
            { name: 'St. Pauli', postalCode: '20359' },
            { name: 'Eimsbüttel', postalCode: '20255' },
            { name: 'Altona', postalCode: '22765' },
            { name: 'Winterhude', postalCode: '22299' },
          ]
        },
      ]
    },
    {
      name: 'Nordrhein-Westfalen',
      cities: [
        {
          name: 'Köln',
          districts: [
            { name: 'Altstadt', postalCode: '50667' },
            { name: 'Ehrenfeld', postalCode: '50823' },
            { name: 'Nippes', postalCode: '50733' },
            { name: 'Südstadt', postalCode: '50677' },
          ]
        },
        {
          name: 'Düsseldorf',
          districts: [
            { name: 'Altstadt', postalCode: '40213' },
            { name: 'Bilk', postalCode: '40225' },
            { name: 'Flingern', postalCode: '40233' },
            { name: 'Oberkassel', postalCode: '40545' },
          ]
        },
      ]
    },
  ]
};

// 法国地址数据
export const franceAddressData: OverseasCountry = {
  name: '法国',
  code: 'FR',
  postalCodeFormat: '5位数字',
  streetFormats: [
    '{number} Rue de la Paix',
    '{number} Avenue des Champs-Élysées',
    '{number} Boulevard Saint-Germain',
    '{number} Rue du Faubourg Saint-Honoré',
    '{number} Place de la Concorde',
    '{number} Rue de Rivoli',
    '{number} Avenue Montaigne',
    '{number} Rue Saint-Honoré',
    '{number} Boulevard Haussmann',
    '{number} Rue de la République',
  ],
  addressLine2Formats: [
    'Appartement {apt}',
    'Étage {floor}',
    'Bâtiment {building}',
  ],
  states: [
    {
      name: 'Île-de-France',
      cities: [
        {
          name: 'Paris',
          districts: [
            { name: '1er Arrondissement', postalCode: '75001' },
            { name: '2e Arrondissement', postalCode: '75002' },
            { name: '3e Arrondissement (Le Marais)', postalCode: '75003' },
            { name: '4e Arrondissement', postalCode: '75004' },
            { name: '5e Arrondissement (Quartier Latin)', postalCode: '75005' },
            { name: '6e Arrondissement (Saint-Germain)', postalCode: '75006' },
            { name: '7e Arrondissement', postalCode: '75007' },
            { name: '8e Arrondissement', postalCode: '75008' },
            { name: '9e Arrondissement', postalCode: '75009' },
            { name: '10e Arrondissement', postalCode: '75010' },
            { name: '11e Arrondissement', postalCode: '75011' },
            { name: '16e Arrondissement', postalCode: '75016' },
            { name: '18e Arrondissement (Montmartre)', postalCode: '75018' },
          ]
        },
      ]
    },
    {
      name: 'Provence-Alpes-Côte d\'Azur',
      cities: [
        {
          name: 'Marseille',
          districts: [
            { name: 'Vieux-Port', postalCode: '13001' },
            { name: 'Le Panier', postalCode: '13002' },
            { name: 'Prado', postalCode: '13008' },
          ]
        },
        {
          name: 'Nice',
          districts: [
            { name: 'Vieux Nice', postalCode: '06300' },
            { name: 'Promenade des Anglais', postalCode: '06000' },
            { name: 'Cimiez', postalCode: '06000' },
          ]
        },
      ]
    },
    {
      name: 'Auvergne-Rhône-Alpes',
      cities: [
        {
          name: 'Lyon',
          districts: [
            { name: 'Presqu\'île', postalCode: '69002' },
            { name: 'Vieux Lyon', postalCode: '69005' },
            { name: 'Part-Dieu', postalCode: '69003' },
            { name: 'Croix-Rousse', postalCode: '69004' },
          ]
        },
      ]
    },
  ]
};

// 韩国地址数据
export const koreaAddressData: OverseasCountry = {
  name: '韩国',
  code: 'KR',
  postalCodeFormat: '5位数字',
  streetFormats: [
    '{dong} {number}번길',
    '{ro}로 {number}',
    '{daero}대로 {number}',
  ],
  addressLine2Formats: [
    '{building}아파트 {dong}동 {ho}호',
    '{building}빌딩 {floor}층',
    '{building}오피스텔 {ho}호',
  ],
  states: [
    {
      name: '서울특별시',
      cities: [
        {
          name: '강남구',
          districts: [
            { name: '역삼동', postalCode: '06235' },
            { name: '삼성동', postalCode: '06178' },
            { name: '청담동', postalCode: '06010' },
            { name: '압구정동', postalCode: '06019' },
            { name: '신사동', postalCode: '06035' },
          ]
        },
        {
          name: '서초구',
          districts: [
            { name: '서초동', postalCode: '06621' },
            { name: '반포동', postalCode: '06502' },
            { name: '잠원동', postalCode: '06510' },
          ]
        },
        {
          name: '마포구',
          districts: [
            { name: '홍대입구', postalCode: '04003' },
            { name: '합정동', postalCode: '04027' },
            { name: '상암동', postalCode: '03925' },
            { name: '연남동', postalCode: '04003' },
          ]
        },
        {
          name: '종로구',
          districts: [
            { name: '광화문', postalCode: '03154' },
            { name: '인사동', postalCode: '03148' },
            { name: '북촌', postalCode: '03052' },
            { name: '삼청동', postalCode: '03049' },
          ]
        },
        {
          name: '용산구',
          districts: [
            { name: '이태원동', postalCode: '04348' },
            { name: '한남동', postalCode: '04417' },
            { name: '용산역', postalCode: '04323' },
          ]
        },
      ]
    },
    {
      name: '부산광역시',
      cities: [
        {
          name: '해운대구',
          districts: [
            { name: '해운대', postalCode: '48094' },
            { name: '센텀시티', postalCode: '48058' },
            { name: '마린시티', postalCode: '48119' },
          ]
        },
        {
          name: '부산진구',
          districts: [
            { name: '서면', postalCode: '47285' },
            { name: '전포동', postalCode: '47298' },
          ]
        },
      ]
    },
    {
      name: '인천광역시',
      cities: [
        {
          name: '연수구',
          districts: [
            { name: '송도동', postalCode: '21984' },
            { name: '연수동', postalCode: '21930' },
          ]
        },
      ]
    },
  ]
};

// 所有支持的国家列表
export const supportedCountries = [
  { name: '中国', code: 'CN' },
  { name: '美国', code: 'US' },
  { name: '英国', code: 'UK' },
  { name: '日本', code: 'JP' },
  { name: '加拿大', code: 'CA' },
  { name: '澳大利亚', code: 'AU' },
  { name: '德国', code: 'DE' },
  { name: '法国', code: 'FR' },
  { name: '韩国', code: 'KR' },
];

// 获取国家地址数据
export const getCountryAddressData = (countryCode: string): OverseasCountry | null => {
  switch (countryCode) {
    case 'US': return usaAddressData;
    case 'UK': return ukAddressData;
    case 'JP': return japanAddressData;
    case 'CA': return canadaAddressData;
    case 'AU': return australiaAddressData;
    case 'DE': return germanyAddressData;
    case 'FR': return franceAddressData;
    case 'KR': return koreaAddressData;
    default: return null;
  }
};
